import React from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

type FitOptionFullWidthProps<T extends string> = {
  onSelect: (id: T, index: number) => void
  selected: boolean
  index: number
  value: string
  id: T
  height?: number
  classes?: string
  step?: string
}

function FitOptionFullWidth<T extends string>({
  onSelect,
  selected,
  classes,
  index,
  height,
  value,
  step,
  id
}: FitOptionFullWidthProps<T>) {
  const fitOptionClasses = classNames(
    `${styles.options__item} ${styles.options__item_fullWidth} ${
      classes || ''
    }`,
    {
      [styles.selected]: selected
    }
  )

  return (
    <li className={fitOptionClasses} style={{ height }}>
      <button type="button" onClick={() => onSelect(id, index)}>
        {!!step && <div className={styles.options__item__listType}>{step}</div>}
        <div className={styles.options__item__listDescription}>{value}</div>
      </button>
    </li>
  )
}

export default FitOptionFullWidth
